// extracted by mini-css-extract-plugin
export var button = "LaunchButton-module--button--82ee7";
export var cdsAssistiveText = "LaunchButton-module--cds--assistive-text--a5bd3";
export var cdsHideFeedback = "LaunchButton-module--cds--hide-feedback--3db52";
export var cdsShowFeedback = "LaunchButton-module--cds--show-feedback--f7bfa";
export var cdsSkeleton = "LaunchButton-module--cds--skeleton--3038d";
export var cdsVisuallyHidden = "LaunchButton-module--cds--visually-hidden--c1059";